import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  BreederWriteReviewCreateReviewMutation,
  BreederWriteReviewCreateReviewMutationVariables,
} from '@gql/graphql';
import type { BreederWriteReviewFormValues } from '@presentation/components';
import { useCallback } from 'react';
import { BREEDER_GET_BREEDER } from '../../BreederPageController/api/useGetBreeder';
import { BREEDER_GET_REVIEWS } from '../../BreederPageController/api/useGetReviews';

export const BREEDER_WRITE_REVIEW_CREATE_REVIEW = graphql(`
  mutation BreederWriteReviewCreateReview($data: CreateDogBreederReviewInput!) {
    createDogBreederReview(data: $data) {
      id
    }
  }
`);

export const useWriteReview = () => {
  const [write, { data, loading, error }] = useMutation<
    BreederWriteReviewCreateReviewMutation,
    BreederWriteReviewCreateReviewMutationVariables
  >(BREEDER_WRITE_REVIEW_CREATE_REVIEW, {
    awaitRefetchQueries: true,
    refetchQueries: [BREEDER_GET_REVIEWS, BREEDER_GET_BREEDER],
  });

  const writeReviewFromFrom = useCallback(
    (form: BreederWriteReviewFormValues, dogBreederId?: number) => {
      if (!dogBreederId) throw new Error('dogBreederId is not defined');

      return write({
        variables: {
          data: {
            dogBreederId,
            contactDate: form.contactDate?.toISOString(),
            contactType: form.contactType,
            globalGrade: form.globalGrade,
            humanContactGrade: form.humanContactGrade,
            hygieneGrade: form.hygieneGrade,
            followUpGrade: form.followUpGrade,
            dogsWellBeingGrade: form.dogsWellBeingGrade,

            description: form.description,
          },
        },
      });
    },
    [write],
  );

  return {
    writeReviewFromFrom,
    writeReviewLoading: loading,
    writeReviewData: data,
    writeReviewError: error,
  };
};
